import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { useFormContext } from "react-hook-form";
import SignaturePad from "../../../../components/UI/SignaturePad";

/**
 * Per-entry patient canvas signature for Route Sheet.
 * Mirrors clinical Eval/Orders SignaturePad behaviour:
 * - draw → pending data URL
 * - saved → show image via patientSignatureUrl
 * - clear / re-sign → clearPatientSignature flag
 */
const EntryPatientSignature = ({
  index,
  disabled = false,
  height = 88,
}) => {
  const { watch, setValue } = useFormContext();
  const prefix = `entries.${index}`;

  const patientSignatureUrl = watch(`${prefix}.patientSignatureUrl`);
  const patientSignatureImage = watch(`${prefix}.patientSignatureImage`);
  const clearPatientSignature = watch(`${prefix}.clearPatientSignature`);

  const displayValue =
    !clearPatientSignature && (patientSignatureImage || patientSignatureUrl);

  const handleDraw = useCallback(
    (dataUrl) => {
      setValue(`${prefix}.patientSignatureImage`, dataUrl, {
        shouldDirty: true,
      });
      setValue(`${prefix}.clearPatientSignature`, false, { shouldDirty: true });
    },
    [prefix, setValue],
  );

  const handleClear = useCallback(() => {
    setValue(`${prefix}.patientSignatureImage`, "", { shouldDirty: true });
    setValue(`${prefix}.clearPatientSignature`, true, { shouldDirty: true });
    setValue(`${prefix}.patientSignatureUrl`, "", { shouldDirty: true });
  }, [prefix, setValue]);

  return (
    <SignaturePad
      value={displayValue || ""}
      disabled={disabled}
      height={height}
      placeholder="Patient sign here"
      onChange={handleDraw}
      onClear={handleClear}
      className="min-w-[160px]"
    />
  );
};

EntryPatientSignature.propTypes = {
  index: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  height: PropTypes.number,
};

export default EntryPatientSignature;
